import type {
  GetDocumentsVersionsRequestType,
  GetDocumentsVersionsResponseType,
} from 'entities/document/api/types';
import { stringifyUrlQuery } from 'helpers';
import { apiAuthClient } from 'shared/api/lib/apiAuthClient';

export const getDocumentsVersions = async (
  queryParams: GetDocumentsVersionsRequestType,
) => {
  const defaultParams = {
    perPage: '100',
  };
  const query = stringifyUrlQuery({ ...defaultParams, ...queryParams });

  const url = `/api/v2/documents/${queryParams.documentId}/versions${query}`;
  const response =
    await apiAuthClient.get<GetDocumentsVersionsResponseType>(url);

  return response.data;
};
